module.exports = new __parcel__URL__("GT_P_1Blau_reduziert_003.86d6a6f7.json").toString();